import React from 'react'

import { compose } from '@reduxjs/toolkit'
import { NextSeo } from 'next-seo'
import { connect } from 'react-redux'
import { ConfigProps, reduxForm } from 'redux-form'

import DealerForm from '~/components/forms/DealerForm/DealerForm'
import AppLayout from '~/components/layouts/AppLayout'

import { AppState } from '~/state/store'
import withAuth, { ROLES } from '~/utils/withAuth'

const DealerCreationPage = () => {
  return (
    <>
      <NextSeo
        title="Create Dealer"
        description="Create Dealer"
        openGraph={{
          title: 'Create Dealer',
          description: 'Create Dealer'
        }}
      />
      <AppLayout>
        <Form />
      </AppLayout>
    </>
  )
}

const mapStateToProps = (
  state: AppState
): Pick<ConfigProps, 'initialValues'> => {
  const { name, email, phone } = state.user
  return {
    initialValues: {
      contact_name: name,
      email,
      phone
    }
  }
}

const withConnet = connect(mapStateToProps)

const withForm = reduxForm({
  form: 'Dealer_Creation_Form',
  destroyOnUnmount: false,
  enableReinitialize: true
})

const Form = compose<any>(withConnet, withForm)(DealerForm)

export default withAuth([ROLES.dealer, ROLES.user])(DealerCreationPage)
